import React, { Component } from 'react';
import InputField from '../../components/inputs/inputField';
import ToggleField from '../../components/inputs/toggleField';
import API from '../../utils/API';

class AgencyInfo extends Component {
	constructor(props) {
		super(props);
		const { venue } = props;
		
		this.state = {
			editedVenue: {
				agencyInfo: venue.agencyInfo || {
					isCommissionable: false,
					agencyName: '',
					iataNumber: '',
					address: {
						country: 'US',
						state: '',
						city: '',
						zipCode: ''
					}
				}
			},
			editing: false,
			saving: false
		};
	}

	updateAgencyInfo = (field, value) => {
		const { editedVenue } = this.state;
		editedVenue.agencyInfo[field] = value;
		this.setState({ editedVenue, editing: true });
	};

	updateAddress = (field, value) => {
		const { editedVenue } = this.state;
		editedVenue.agencyInfo.address[field] = value;
		this.setState({ editedVenue, editing: true });
	};

	saveDetails = async () => {
		this.setState({ saving: true });
		
		try {
			await API().patch(
				`Organizations/${this.props.orgId}/sourced-venues/${this.props.venueId}`,
				{ agencyInfo: this.state.editedVenue.agencyInfo }
			);
			
			this.setState({ editing: false, saving: false });
			this.props.refreshSectionCounts && this.props.refreshSectionCounts();
		} catch (error) {
			console.error('Error saving agency info:', error);
			this.setState({ saving: false });
		}
	};

	cancelEdit = () => {
		const { venue } = this.props;
		this.setState({
			editedVenue: {
				agencyInfo: venue.agencyInfo || {
					isCommissionable: false,
					agencyName: '',
					iataNumber: '',
					address: {
						country: 'US',
						state: '',
						city: '',
						zipCode: ''
					}
				}
			},
			editing: false
		});
	};

	render() {
		const { editedVenue, editing } = this.state;
		const { venue } = this.props;
		const { agencyInfo } = editedVenue;
		
		return (
			<div className="sectionContainer">
				
				<div className="sectionBody">
					<div className="sectionBlock">
						<h2 className="blockHeader">Agency Details</h2>
						
						<ToggleField
							label="Is this booking commissionable?"
							checked={agencyInfo.isCommissionable}
							onChange={() => this.updateAgencyInfo('isCommissionable', !agencyInfo.isCommissionable)}
							icons={false}
						/>
						
						<InputField
							label="3rd Party Agency Name"
							value={agencyInfo.agencyName}
							onChange={(e) => this.updateAgencyInfo('agencyName', e.target.value)}
							placeholder="Enter agency name"
						/>
						
						<InputField
							label="3rd Party Agency IATA Number"
							value={agencyInfo.iataNumber}
							onChange={(e) => this.updateAgencyInfo('iataNumber', e.target.value)}
							placeholder="Enter IATA number"
						/>
					</div>
					
					<div className="sectionBlock">
						<h2 className="blockHeader">Agency Address</h2>
						
						<InputField
							label="Country"
							value={agencyInfo.address.country}
							onChange={(e) => this.updateAddress('country', e.target.value)}
						/>
						
						<div className="flex wrap" style={{ gap: '15px' }}>
							<div style={{ flex: '1 1 250px' }}>
								<InputField
									label="State/Province"
									value={agencyInfo.address.state}
									onChange={(e) => this.updateAddress('state', e.target.value)}
									placeholder="CA"
								/>
							</div>
							<div style={{ flex: '1 1 250px' }}>
								<InputField
									label="City"
									value={agencyInfo.address.city}
									onChange={(e) => this.updateAddress('city', e.target.value)}
									placeholder="San Francisco"
								/>
							</div>
						</div>
						
						<InputField
							label="Zip Code"
							value={agencyInfo.address.zipCode}
							onChange={(e) => this.updateAddress('zipCode', e.target.value)}
							placeholder="94102"
						/>
					</div>
				</div>
				
			</div>
		);
	}
}

export default AgencyInfo;
